import React from "react";

const ColumnHeader = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => (
  <div className="d-flex flex-column lh-1">
    <span>{title}</span>
    {subtitle ? (
      <small
        className="text-muted fw-normal mt-1 d-inline-block"
        style={{ whiteSpace: "pre-line" }}
      >
        {subtitle}
      </small>
    ) : null}
  </div>
);

export default ColumnHeader;
